import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';

import Main from '../../../layouts/Main';
import Container from '../../../components/Container';
import {Card, Divider, Link } from '@mui/material';
import PageBreadcrumbs from '../../../components/PageBreadcrumbs';

const Message = (): JSX.Element => {

  return (
    <Main>
      <Container>
        <PageBreadcrumbs></PageBreadcrumbs>
        <Typography
            variant="h5"
            align={'left'}
            data-aos={'fade-up'}
            sx={{
                fontWeight: 700,
            }}
            paddingTop={3}
            gutterBottom
            marginBottom={2}
            >
            A Message From The Director
        </Typography>
        <Divider/>
        <Grid container marginTop={3}>
            <Grid 
              padding={3}
              size={12}
              component={Card}
              boxShadow={1}
              >
              <Typography variant='subtitle1' fontWeight={550} marginBottom={2}>Welcome!</Typography>
              <Typography component={'p'} variant='body1'  marginBottom={2}>
                OCPF is an independent agency charged with overseeing compliance with the campaign finance law. 
                Established in 1973, the agency has roots in laws passed in the late 19th century when the public 
                began to demand transparency in the funding of election campaigns.
              </Typography>
              <Typography component={'p'} variant='body1'  marginBottom={2}>
                The agency emphasizes education to assist the public and candidates in understanding and complying with the law. 
                Through guides, videos and memos posted to this website, online and in-person educational programs, 
                and the availability of staff to provide guidance, the aim is to reduce barriers to compliance for candidates and, in turn, 
                provide the public with relevant campaign finance information.
              </Typography>
              <Typography component={'p'} variant='body1'  marginBottom={2}>
                  Interested persons and stakeholders can access and review candidate and committee information in our online databases 
                  for offices such as statewide, legislators and mayors. Candidates for local offices, such as select boards and school committees, 
                  file with city and town clerks and election commissioners. Each year, thousands of filed reports are reviewed for legality, 
                  validity, completeness and accuracy at both the state and local levels. All these reports are open for public inspection.
              </Typography>
              <Typography component={'p'} variant='body1'  marginBottom={2}>
                  If you have any questions or need guidance, we encourage you to contact our office by <Link underline='none' href={'mailto:ocpf@mass.gov'}>e-mail</Link>, or call 617-979-8300.
              </Typography>
              <Typography component={'p'} variant='body1'  marginBottom={2}>
                  William C. Campbell, Director
              </Typography>
            </Grid>
        </Grid>
      </Container>
    </Main>
  );
};

export default Message;